<nav class="poster-tools" aria-label="掲示用の操作">
  <button mat-stroked-button (click)="back()">出欠・参加管理へ戻る</button>
  <button mat-raised-button class="print-button" [disabled]="!qrDataUrl" (click)="print()">印刷・PDF保存</button>
</nav>

@if (showSpinner) {
  <div class="poster-loading"><mat-spinner diameter="52"></mat-spinner></div>
} @else if (errorMessage) {
  <main class="poster-error"><p role="alert">{{ errorMessage }}</p><button mat-stroked-button (click)="back()">出欠・参加管理へ戻る</button></main>
} @else {
  <main class="poster-sheet">
    <h1>{{ title }}</h1>
    <div class="schedule-list">
      @for (item of schedules; track $index) { <p>{{ scheduleLabel(item) }}</p> }
    </div>
    <h2>スマートフォンで読み取ってください</h2>
    <p class="common-label">事前回答・当日出席 共通QR</p>
    <img class="poster-qr" [src]="qrDataUrl" width="360" height="360" alt="出欠依頼URLのQRコード">
    <p class="poster-url">{{ participantUrl }}</p>
    <div class="poster-steps">
      <section><strong>事前のご案内</strong><span>出席予定・欠席予定を回答</span></section>
      <section><strong>当日</strong><span>「出席登録する」を押す</span></section>
    </div>
    <p class="poster-note">NESTの対象者用です。未ログインの場合はログイン後、この画面へ戻ります。<br>QRを読み取っただけでは出席登録は完了しません。</p>
  </main>
}
